import {segment} from './helpers'

/**
 * Fired when we want to know that a user saw a particular modal message
 *
 * @param {Object} props
 * @param {String} props.message A description of the modal's message
 */
export const viewedModal = ({message}) => segment('Viewed Modal', {message})
